// extracted by mini-css-extract-plugin
export default {"card":"Card_card__yharB","card__header":"Card_card__header__Sepye","card__content":"Card_card__content__6GZ74"};